export default __webpack_public_path__ + "static/media/temp1.7b3dc0a5.png";